<template>
  <div class="diadin">



    <el-form :inline="true" :model="formInline" class="demo-form-inline">


      <el-form-item>
        <el-input style="width: 300px" :placeholder="`${$t('menu.PartName')}/${$t('menu.Code')}`"
          v-model="formInline.title"></el-input>
      </el-form-item>

      <el-form-item>
        <el-select v-model="formInline.category" :placeholder="$t('menu.VehicleModel')" clearable
          @change="changeCheXing">
          <el-option v-for="item in list" :label="item.seriesModel" :value="item.id" :key="item.id"
            v-if="item.id !== 9000 && inle == 'zh'"></el-option>
          <el-option v-for="item in list" :label="item.seriesModelEn" :value="item.id" :key="item.id"
            v-if="item.id !== 9000 && inle !== 'zh'"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="onSubmit(2)">{{ $t('menu.search') }}</el-button>
      </el-form-item>

      <div style="width: 100%;height: 1px; background-color: #eee;margin-bottom: 30px;"></div>

    </el-form>
    <div class="box" style="display: flex;height: 900px;" v-if="pcc == false">



      <div class="rightbox" style="min-width: 25vw; border: 1px solid #eee;">

        <div class="fg"></div>
        <div class="infinite-list-wrapper" style="
            overflow: auto;
            height: 100%;
            width: 100%;
          ">


          <div v-for="(item, index) in mation1" :key="index" class="list-item">
            <div class="right-item1" style="width: 100%;height: 100%;">
              <div class="left1" style="display: flex;align-items: center;width: 30%;">
                <template>
                  <!-- <el-image v-if="item.detailImageList" style="width: 150px; height: 120px" :src="url"
                      :preview-src-list="item.detailImageList">
                    </el-image>
                    <el-image v-else style="width: 150px; height: 120px" :src="url">
                    </el-image> -->
                  <!-- <div class="index1">{{ item.diagramNum }}</div> -->
                </template>
                <div class="product-info1">
                  <div class="name-info1">
                    <p class="partName" style="text-decoration: underline;cursor: pointer;" @click="openDetails(item)">
                      {{ inle == 'zh' ? item.partName : item.partNameEn
                      }}</p>
                    <p>{{ item.partNumber }}</p>

                    <p>{{sxtitle( item.partCategory)
                     }}</p>
                    <p v-if="item.relationList.length > 0">{{ $t('menu.Alternative') }}：<span
                        v-for="(e, i) in item.relationList" :key="i">{{
                          e.part.partNumber }}
                        <span v-if="i < item.relationList.length - 1">、</span> </span></p>

                    <!-- <div class="details">{{item.createdTime}},单元用量：2 莫得灵黑</div> -->
                     <div v-if="tup==2&&item.partRetailer!==null" style="display: flex;">
                       <div class="kcbox" :style="item.partRetailer.currentStock>item.partRetailer.safetyStock?{backgroundColor:'#9df29f'}:{}"></div>
                      <div class="kcbox" :style="item.partRetailer.safetyStock>item.partRetailer.currentStock&&item.partRetailer.currentStock>0?{backgroundColor:'#f9d106'}:{}"></div>
                      
                       <div class="kcbox" :style="item.partRetailer.currentStock==0?{backgroundColor:'#f91c16'}:{}"></div>
                  </div>
                  </div>
                  
                </div>
               
 
                <div class="price" v-if="bz == 'CNY'&&pict==0" style="min-width: 22%;">￥{{ item.purchasePriceCny }} <span
                    class="pricea">{{
                      pjst(item.unit)
                    }}</span> </div>
                <div class="price" v-if="bz == 'USD'&&pict==0" style="min-width: 22%;">${{ item.purchasePriceUsd }} <span
                    class="pricea">{{
                      pjst(item.unit)
                    }}</span> </div>

                <div class="price" v-if="bz == 'EUR'&&pict==0" style="min-width: 22%;">€{{ item.purchasePriceEur }} <span
                    class="pricea">{{
                      pjst(item.unit)
                    }}</span> </div>
            
              
                 <div class="price" v-if="bz == 'CNY'&&pict==1" style="min-width: 22%;">￥{{  numFilter(item.purchasePriceCny/0.65) }} <span
                    class="pricea">{{
                      pjst(item.unit)
                    }}</span> </div>
                <div class="price" v-if="bz == 'USD'&&pict==1" style="min-width: 22%;">${{ numFilter(item.purchasePriceUsd/0.65) }} <span
                    class="pricea">{{
                      pjst(item.unit)
                    }}</span> </div>

                <div class="price" v-if="bz == 'EUR'&&pict==1" style="min-width: 22%;">€{{ numFilter(item.purchasePriceEur/0.65) }} <span
                    class="pricea">{{
                      pjst(item.unit)
                    }}</span> </div>
                 
               
                <div  class="qqq">{{ inle == 'zh' ?
                  item.mcSeriesModel.seriesModel : item.mcSeriesModel.seriesModelEn
                  }}</div>
              </div>
              <div class="right" style="display: flex;flex: 1;align-items: center;min-width: 30%;">
                <div class="num-box">
                  <el-input-number v-model="item.buyNum" :min="item.minPurchaseQuantity" size="mini"
                    @change="changeNum($event, item.minPurchaseQuantity, index,)"></el-input-number>
                  <!-- <p v-if="item.show" style="color: red;">最小采购量：{{ item.minPurchaseQuantity }}</p> -->
                </div>
                <div class="btn-box1">
                     <el-button type="primary" v-if="item.status == true&&tup=='2'&&item.partRetailer!==null" class="btn buy"
                    :disabled="item.partRetailer.status!==1"
                    :class="[item.btnType == true || item.status == false||item.partRetailer.status!==1 ? 'hui' : '']" @click="buyCart(item, index)">
                    <div style="display: flex; align-items: center; justify-content: center;"><img class="ico"
                        src="../../assets/images/PC20240924-103854.png" alt="">
                      <div class="jyyy">{{ item.btnType == true || item.status
                        ==
                        false ? $t('menu.Add') : $t('menu.Add') }}</div>
                    </div> 
                  </el-button>
                  <el-button type="primary" v-if="item.status == true&&tup=='2'&&item.partRetailer==null" class="btn buy hui"
                    disabled
                     @click="buyCart(item, index)">
                    <div style="display: flex; align-items: center; justify-content: center;"><img class="ico"
                        src="../../assets/images/PC20240924-103854.png" alt="">
                      <div class="jyyy">{{ item.btnType == true || item.status
                        ==
                        false ? $t('menu.Add') : $t('menu.Add') }}</div>
                    </div> 
                  </el-button>


                  <el-button type="primary" v-if="item.status == true&&tup!=='2'" class="btn buy"
                    :disabled="item.btnType == true || item.status == false"
                    :class="[item.btnType == true || item.status == false ? 'hui' : '']" @click="buyCart(item, index)">
                    <div style="display: flex; align-items: center; justify-content: center;"><img class="ico"
                        src="../../assets/images/PC20240924-103854.png" alt="">
                      <div class="jyyy">{{ item.btnType == true || item.status
                        ==
                        false ? $t('menu.Add') : $t('menu.Add') }}</div>
                    </div>
                  </el-button>
                  <el-button type="primary" v-if="item.status == false" class="btn buy"
                    :disabled="item.btnType == true || item.status == false"
                    :class="[item.btnType == true || item.status == false ? 'hui' : '']" @click="buyCart(item, index)">
                    <div style="display: flex; align-items: center; justify-content: center;">
                      <!-- <img class="ico"
                        src="../../assets/images/PC20240924-103854.png" alt=""> -->
                      <div class="jyyy">{{ item.btnType == true || item.status
                        ==
                        false ? $t('menu.Soldout') : $t('menu.Add') }}</div>
                    </div>
                  </el-button>
                  <!-- <div class="btn end">已停供</div> -->
                </div>
              </div>



            </div>
          </div>





        </div>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="page"
          :page-size="10" layout="total, prev, pager, next" :total="totale">
        </el-pagination>
      </div>
    </div>
    <div class="box" style="display: flex;height: 900px;" v-if="pcc == true">
      搜索暂无数据。。。
    </div>
    <el-dialog :title="inle == 'zh' ? detailsObj.partName : detailsObj.partNameEn" :visible.sync="detailsFlag" width="30%">
      <div class="details-box">
        <div class="text-box">
          <div>
            {{ $t('menu.unit') }}:{{ detailsObj.defaultPerVehicleUsage }}
          </div>

          <div v-if="detailsObj.effectiveDate !== undefined">
            {{ $t('menu.Effectivedate') }}:{{ detailsObj.effectiveDate.slice(0, 10) }}
          </div>
          <div v-else>
            {{ $t('menu.Effectivedate') }}:{{ detailsObj.effectiveDate }}
          </div>

          <div>
            {{ $t('menu.MinimumPurchaseQuantity') }}:{{ detailsObj.minPurchaseQuantity }}
          </div>
        </div>

        <div class="shuoming">
          {{ detailsObj.remarks }}
        </div>


        <div class="img-box-details">
          <el-image class="elimg" v-for="item in detailsImgList" :src="item" alt=""
            :preview-src-list="detailsImgList"></el-image>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import {
  addCart,
  listMcSeriesModels,
  pageQueryPart,
  pageQueryPartCategory,
  pageQueryParta,
  pageQueryParta1,
  querytype
} from "../../api/api";

export default {

  data () {
    return {
      active: 2,
      list: [],
      mation: [],
      mation1: [],
      loading: false,
      mcSeriesModelId: '',
      seriesModel: "",
      categoryId: "",
      categoryName: "",
      page: 1,
      totale: 0,
      url: '',
      show: false,
      formInline: {
        title: "",
        status: "",
        startTime: "",
        endTime: "",
        contact: "",
        category: "",
        type: "",
      },
      urlList: [],
      urlItem: '',
      pcc: false,
      prList: [],
      bz: 'CNY',
      detailsFlag: false,
      detailsObj: {},
      detailsImgList: [],
      inle: 'zh',
      tup:1,
      pict:0,
    };
  },
  created () {
    let a = sessionStorage.getItem('i18n')
     this.tup = sessionStorage.getItem('platform')
    this.inle = a
     this.pict=sessionStorage.getItem('picaetype')||0
    this.listMcSeriesModel();
    this.biao();
    this.jg()
    this.bz = sessionStorage.getItem('shbz')
  },
  computed: {
    noMore () {
      return this.page >= this.totale;
    },
    disabled () {
      return this.loading || this.noMore;
    },
  },
  watch: {
    mation1: {
      handler (newVal, oldVal) {
      },
      deep: true
    }
  },
  methods: {
      numFilter (value) {
          let realVal = ''
        if(value!==undefined&&value!==null&&value!==''){
         realVal = Number(value).toFixed(2)
        }
    // 截取当前数据到小数点后两位
  
    return realVal
  },
    sxtitle(e){
      let a =''
        // console.log(11,JSON.parse(e.categoryNameEn));
        
      if(this.inle=='zh'){
        a=e.categoryName
      }
    if(this.inle=='en'){
      if(e.categoryNameEn.indexOf(":") !== -1){
       
        let c =JSON.parse(e.categoryNameEn)
     
        a=c.en
      }else{
        a=e.categoryNameEn
      }
      

      }
      if(this.inle=='de'){
         if(e.categoryNameEn.indexOf(":") !== -1){
             let d =JSON.parse(e.categoryNameEn)
        a=d.de
         } else{
        a=e.categoryNameEn
      } 
         
      
      }
      return a

    },
    openDetails (item) {
      this.detailsImgList = []
      console.log(item)
      this.detailsObj = item
      if (this.detailsObj.detailImageList !== null) {
        this.detailsImgList = this.detailsObj.detailImageList.split(',')
      }
      this.detailsFlag = true
    },
    jg () {
      let param = new URLSearchParams();
      querytype(param, 't_part_unit').then(r => {
        if (r.data.code == 200) {
          this.prList = r.data.data
        }
      })
    },
    pjst (e) {
      let a = this.prList
      let b = ''
      a.forEach(z => {
        if (e == z.dictValue && this.inle == 'zh') {
          b = z.dictLabel

        }
        if (e == z.dictValue && this.inle !== 'zh') {
          b = z.dictLabelEn

        }
      })
      return '/' + b
    },
    changeNum (e, min, index) {
      console.log(e, index)
      if (e == min) {
        this.mation1[index].show = true
      }
      setTimeout(() => {
        this.mation1[index].show = false

      }, 5000);
      this.$forceUpdate()
    },
    setActive (num) {
      this.active = num
    },
    setImgUrl (url) {
      this.urlItem = url
    },
    buyCart (item, index) {
      this.mation1[index].btnType = true
      let a =1
      if(item.mcSeriesModel.mcCategory.dictValue!=="Motorcycle"){
        a=3
      }
      this.$forceUpdate()
      let param = new URLSearchParams();
      addCart(
        param,
        item.id,
        item.buyNum,
        a
      ).then(r => {
        console.log(r)
        if (r.data.code == 200) {
          this.$message.success(this.$t('menu.SUCESS'))
          setTimeout(() => {
            this.mation1[index].btnType = false
            this.$forceUpdate()
          }, 1000);
        } else {
          setTimeout(() => {
            this.mation1[index].btnType = false
            this.$forceUpdate()
          }, 1000);
        }
      })

    },
    changeCheXing (e) {
      this.mcSeriesModelId = e
      this.list.forEach(i => {
        if (i.id === e) {
          this.seriesModel = i.seriesModel
        }
      })
      this.biao()
    },
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange (val) {
      this.page = val
      this.pageQueryParts();
      console.log(`当前页: ${val}`);
    },
    async biao () {
      this.page = 1
      let param = new URLSearchParams();
      let mcSeriesModelId = this.mcSeriesModelId;
      let searchKey = this.formInline.title;

      const { data: res } = await pageQueryParta(
        param,
        this.page,
        '10&order=status',
        mcSeriesModelId,
        searchKey
      );
      this.mation1 = res.data.list
      res.data.list.forEach((e, i) => {
        this.mation1[i].buyNum = e.minPurchaseQuantity

      });
      this.totale = res.data.total;
      if (res.data.total > 0) {
        this.pcc = false
      } else {
        this.pcc = true
      }


    },
    //获取车型
    async listMcSeriesModel () {
      let param = new URLSearchParams();

      const { data: res } = await listMcSeriesModels(param);

      this.list = res.data;
      // this.formInline.category = this.mcSeriesModelId
      // this.seriesModel = this.list[0].seriesModel;
    },
    //配件查询
    async pageQueryParts () {
      //配件查询

      let param = new URLSearchParams();
      let mcSeriesModelId = this.mcSeriesModelId;
      let searchKey = this.formInline.title;

      const { data: res } = await pageQueryParta(
        param,
        this.page,
        '10&order=status',
        mcSeriesModelId,
        searchKey
      );
      this.mation1 = res.data.list
      res.data.list.forEach((e, i) => {
        this.mation1[i].buyNum = e.minPurchaseQuantity

      });

      this.totale = res.data.total;
      if (res.data.total > 0) {
        this.pcc = false
      } else {
        this.pcc = true
      }
    },
    async onsubtitle (e, i) {
      this.categoryId = e
      this.page = 1
      let param = new URLSearchParams();
      let mcSeriesModelId = this.mcSeriesModelId;
      let searchKey = this.formInline.title;
      let categoryId = e;
      const { data: res } = await pageQueryPart(
        param,
        this.page,
        '10&order=status',
        mcSeriesModelId,
        searchKey,
        categoryId
      );
      this.mation1 = res.data.list
      res.data.list.forEach((e, i) => {
        this.mation1[i].buyNum = e.minPurchaseQuantity

      });
      this.urlList = this.mation1[0].partCategory.diagramImageList.split(',')
      this.urlItem = this.urlList[0]
      if (this.totale !== res.data.pages) {
        this.totale = res.data.pages;
      }
      this.categoryName = i
    },
    load () {
      this.loading = true;
      if (this.mation1 >= this.totale == false) {
        setTimeout(() => {
          this.page++;
          this.pageQueryParts();
          this.loading = false;
        }, 2000);
      }
    },

    //搜索
    async onSubmit (num) {
      //配件查询
      this.page = 1
      let param = new URLSearchParams();
      let mcSeriesModelId = this.mcSeriesModelId;
      let searchKey = this.formInline.title;
      const { data: res } = await pageQueryParta(
        param,
        this.page,
        '10&order=status',
        mcSeriesModelId,
        searchKey
      );
      this.mation1 = res.data.list
      res.data.list.forEach((e, i) => {
        this.mation1[i].buyNum = e.minPurchaseQuantity
      });
      this.totale = res.data.total;
      if (res.data.total > 0) {
        this.pcc = false
      } else {
        this.pcc = true
      }
    },
  },
};
</script>

<style lang="less" scoped>
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.list-item {
  width: 100%;
  height: 180px;
}
.kcbox{
   width: 16px;
  height: 16px;
  border-radius: 100px;
  background-color: #dbdbdb;
  margin-right: 10px;
  
}
.list-item:hover {
  background-color: #40a0ff27;
}

.diadin {
  width: 100%;
  min-height: 80vh;
  background-color: #fff;
  padding: 20px;
  padding-left: 0;
}

.fg {
  border-bottom: 1px solid #f2f2f2;
  width: 100%;
  margin-bottom: 10px;
}

.name-info1 {
  display: flex;
  height: 40px;
  width: 350px;
  align-items: center;
  margin-bottom: 40px;

  .partName {
    color: #222222;
    font-weight: 550;
    min-width: 200px;
  }
}

.name-info-1 {
  display: flex;
  justify-content: flex-start;
}

.right-item1 {
  width: 100%;
  display: flex;
  // margin-top: 10px;
  align-items: center;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
  margin-bottom: 10px;

  .price {
    color: red;
    margin-left: 50px;
    display: flex;
    align-items: center;
  }
}

.price {
  color: red;
  margin-left: 50px;
  display: flex;
  font-size: 18px;
  font-weight: 600;
  align-items: center;
}

.pricea {
  font-size: 14px;
  font-weight: 400;
  display: inline-block;
  color: #999999;
}

.left {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  width: 30%;
  padding-left: 20px;
}

.chexing {
  height: 30px;
  display: flex;
  align-items: center;
  border-left: 4px solid #409eff;
  padding-left: 20px;
  // margin-bottom: 10px;
}

.qqq {
  margin-left: 80px;
  min-width: 30%;
}

.acta {
  background-color: #beebff;
}

.img-item {
  width: 100px;
  height: 80px;
  cursor: pointer;
  border: 1px solid #eeeeee;
  margin-right: 20px;
}

.acttimg {
  border: 3px solid #409eff;
}

.leftbox {
  width: 28%;
  overflow-y: scroll;


  .big-pj {
    height: 40px;
    cursor: pointer;
    line-height: 40px;
  }
}

.rightbox {
  flex: 1;
  padding-left: 20px;
  padding: 0 0 40px 0;
  height: 100%;
}

.right-item {
  width: 100%;
  display: flex;
  align-items: center;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
  margin-bottom: 10px;

  .price {
    color: red;
    margin-left: 50px;
    display: flex;
    align-items: center;
  }
}

.product-info1 {
  margin-left: 20px;
  display: flex;
  color: #999999;

  .name-info1 {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;

    p {
      margin-bottom: 10px;
    }
  }

}

.product-info {
  // margin-left: 20px;
  width: 300px;
  display: flex;
  justify-content: flex-start;
  color: #999999;

  .name-info {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;

    p {
      // margin-bottom: 10px;
    }
  }

}

.right {
  justify-content: flex-end;
  margin-right: 40px;
  // margin-left: 40px;
}

.index1 {
  margin-left: 10px;
  min-width: 25px;
  height: 25px;
  border-radius: 50%;
  background-color: #409eff;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.num-box1 {
  width: 300px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.num-box {
  // height: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  // margin-top: 70px;

  p {
    // margin-top: 10px;
  }
}

.active {
  color: #409eff;
}

.max-width {
  margin-left: 90px !important;
  // width: 40% !important;
}

/deep/.el-dialog__header {
  padding-right: 80px;
}

/deep/.el-dialog__title {
  word-wrap: break-word;
  word-break: break-all;
  overflow: hidden;
  margin-right: 20px;
}

.btn-box1 {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 300px;

  .btn {
    width: 120px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    cursor: pointer;
  }

  .buy {
    background-color: #409eff;
  }

  .end {
    background-color: #d7d7d7;
  }
}

.btn-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 30px;

  .btn {
    width: 120px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    cursor: pointer;
  }

  .buy {
    background-color: #409eff;
  }

  .end {
    background-color: #d7d7d7;
  }
}

.center-box {
  width: 1700px;
}

/deep/ .el-image {
  width: 100%;
  height: 80%;
}

/deep/.el-input-number {
  width: 130px;
}

.ico {
  width: 20px;
  height: 20px;
}

.line {
  width: 100%;
  height: 2px;
  background-color: #409eff;
  margin-top: 8px;
}

.index {
  min-width: 25px;
  height: 25px;
  border-radius: 50%;
  background-color: #409eff;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tabs {
  display: flex;

  div {
    margin-right: 15px;
    cursor: pointer;

  }
}

.hui {
  background-color: #d7d7d7 !important;
  border: none !important;
}

.jyyy {
  font-size: 16px;
  padding-left: 8px;
}

.img-box-details {
  margin-top: 30px;
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  .elimg {
    width: 200px;
    height: 200px;
    margin-right: 10px;
  }
}

.details-box {
  padding: 20px 0px;
  padding-top: 0;
}

.text-box {
  display: flex;
  flex-wrap: wrap;

  div {
    width: 50%;
    margin-bottom: 20px;
  }
}
</style>